/**
 * Where a chat attachment's bytes are served from.
 *
 * Deliberately an app route rather than a storage URL. A public storage URL
 * leaks the project host and keeps working, without a login, for anyone it is
 * forwarded to — and these are customer receipts and site photos. A signed URL
 * would fix the login part but expires, which is fatal here because the URL
 * used to be *persisted* in `chat_attachments.url` and read back weeks later.
 *
 * Keyed by row id, not storage path: the row is what carries the account, so
 * the route can scope the read without trusting anything in the URL.
 */
export function chatAttachmentUrl(id: string): string {
  return `/api/chat-attachments/${id}`;
}
